import { useEffect } from "react";
import app from "nystem";
import { UseUser } from "nystem-components";

let added = false;

const ViewButtonGoogletagmanager = () => {
  const user = UseUser();

  useEffect(() => {
    if (!user || !user.approved?.includes("ads")) return;

    const { code } = app().settings.googleTagManager || {};
    if (added || !code) return;

    const tag = function () {
      added = true;

      const [w, d, s, l, i] = [window, document, "script", "dataLayer", code];

      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      const f = d.getElementsByTagName(s)[0];
      const j = d.createElement(s);
      const dl = l !== "dataLayer" ? `&l=${l}` : "";
      j.async = true;
      j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
      f.parentNode.insertBefore(j, f);
    };

    if (!added) tag();
  }, [user]);

  return null;
};

export default ViewButtonGoogletagmanager;
